var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45801 7.12498C4.45801 4.51261 4.45801 3.20643 5.26957 2.39487C6.08112 1.58331 7.38731 1.58331 9.99967 1.58331C12.612 1.58331 13.9182 1.58331 14.7298 2.39487C15.5413 3.20643 15.5413 4.51261 15.5413 7.12498V11.875C15.5413 14.4873 15.5413 15.7935 14.7298 16.6051C13.9182 17.4166 12.612 17.4166 9.99967 17.4166C7.38731 17.4166 6.08112 17.4166 5.26957 16.6051C4.45801 15.7935 4.45801 14.4873 4.45801 11.875V7.12498Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20801 15.0417H10.7913",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 1.58331L7.69546 2.00608C7.84815 2.92225 7.9245 3.38034 8.23869 3.65909C8.56645 3.94987 9.03108 3.95831 10 3.95831C10.9689 3.95831 11.4336 3.94987 11.7613 3.65909C12.0755 3.38034 12.1518 2.92225 12.3045 2.00608L12.375 1.58331",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.27632257760fd1abb30f235ad177c913.svg";
export { ForwardRef as ReactComponent };